<template>
  <div class="new-vacancy-page">
    <BasePreloader v-if="pendingLoad"/>
    <VacancyEditProgress
            v-if="windowSizeMixin.width < 1024"
            is-slide
    />
    <h1 v-if="isEditPage" class="new-vacancy-page__title">{{$tNewVacancy('Edit vacancy')}}</h1>
    <h1 v-else class="new-vacancy-page__title">{{$tNewVacancy('Add vacancy')}}</h1>
    <div v-if="isShowContent" class="new-vacancy-page__content">
      <div class="new-vacancy-page__main">
        <div class="new-vacancy-page__manipulation-btns">
          <button type="button"
                  class="new-vacancy-page__manipulate-btn _hot">
            <span class="new-vacancy-page__manipulate-btn-ico">
              <BaseSvg name="ico-flame" width="1.2rem" height="1.5rem"/>
            </span>
            {{$tNewVacancy('Make hot')}}
          </button>
          <button type="button"
                  class="new-vacancy-page__manipulate-btn _to-top">
            <span class="new-vacancy-page__manipulate-btn-ico">
              <BaseSvg name="ico-to-top" width="1.2rem" height="1.2rem"/>
            </span>
            {{$tNewVacancy('Raise to the top')}}
          </button>
        </div>
        <VacancyEditMain v-if="defer(1)" ref="main"/>
      </div>
      <div class="new-vacancy-page__side _media" v-if="windowSizeMixin.width > 1023">
        <StickyContainer v-if="defer(2)">
          <VacancyEditMedia/>
        </StickyContainer>
      </div>
    </div>
    <div v-if="isShowContent" class="new-vacancy-page__content">
      <div v-if="defer(4)" class="new-vacancy-page__main">
        <section class="new-vacancy-page__group">
          <h2 class="new-vacancy-page__group-title">{{$tNewVacancy('Vacancy characteristics')}}</h2>
          <VacancyEditCharacteristics ref="characteristics"/>
        </section>
        <section class="new-vacancy-page__group">
          <h2 class="new-vacancy-page__group-title">{{$tNewVacancy('Place of work')}}</h2>
          <VacancyEditWorkPlace/>
        </section>
        <section class="new-vacancy-page__group">
          <h2 class="new-vacancy-page__group-title">{{$tNewVacancy('Applicant requirements')}}</h2>
          <VacancyEditRequirements/>
        </section>
        <section class="new-vacancy-page__group">
          <h2 class="new-vacancy-page__group-title">{{$tNewVacancy('Useful materials on the vacancy')}}</h2>
          <VacancyEditFiles/>
        </section>
        <BaseAlert :value="$tNewVacancy(computedGeneralError)"
                   class="new-vacancy-page__inline-alert  _error"/>
        <section class="new-vacancy-page__footer">
          <button @click.prevent="onSave(true)"
                  class="new-vacancy-page__save  _with-post  base-btn  base-btn--blue">
            <BaseSvg name="ico-tick"
                     width="1.4rem"
                     height="1.8rem"
                     style="position: relative; top: 0.2rem; margin-right: 0.5rem"/>
            <BasePreloader v-if="isSavingWithPost"/>
            <span :style="{opacity: isSavingWithPost ? 0 : null}">{{$tNewVacancy('Save and publish')}}</span>
          </button>
          <button @click.prevent="onSave(false)"
                  class="new-vacancy-page__save  base-btn  base-btn--outline-grey  base-btn--hover-blue">
            <BasePreloader v-if="isSavingOnly"/>
            <span :style="{opacity: isSavingOnly ? 0 : null}">{{$tNewVacancy('Save')}}</span>
          </button>
        </section>
      </div>
      <div class="new-vacancy-page__side _progress" v-if="windowSizeMixin.width > 1023">
        <StickyContainer v-if="defer(5)">
          <VacancyEditProgress/>
        </StickyContainer>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {http} from '../../axios'
  import VacancyEditMain from '../../components/VacancyEditMain'
  import VacancyEditMedia from "../../components/VacancyEditMedia";
  import VacancyEditProgress from "../../components/VacancyEditProgress";
  import VacancyEditCharacteristics from "../../components/VacancyEditCharacteristics";
  import VacancyEditRequirements from "../../components/VacancyEditRequirements";
  import VacancyEditFiles from "../../components/VacancyEditFiles";
  import VacancyEditWorkPlace from "../../components/VacancyEditWorkPlace";
  import StickyContainer from "../../components/StickyContainer";
  import windowSizeMixin from "../../mixins/windowSizeMixin";
  import defer from "../../mixins/defer";

  export default {
    mixins: [windowSizeMixin, defer()],
    components: {
      VacancyEditWorkPlace,
      VacancyEditFiles,
      VacancyEditRequirements,
      VacancyEditProgress,
      VacancyEditMedia,
      VacancyEditMain,
      VacancyEditCharacteristics,
      StickyContainer
    },
    data() {
      return {
        key: 1,
        job_types: null,
        salary: null,
        schedule: null,
        salaryType: null,
        category: null,
        saved: false,
      }
    },
    computed: {
      ...mapState('vacancyEdit', {
        pendingSave: 'pendingSave',
        pendingLoad: 'pendingLoad',
        saveOnly: 'saveOnly',
        requiredError: 'error',
        loaded: 'loaded',
        vacancy: 'vacancy',
      }),
      isEditPage() {
        return this.isRouteNameMixin('account-edit-vacancy')
      },
      computedGeneralError() {
        return this.requiredError
      },
      isSavingOnly() {
        return this.pendingSave && this.saveOnly === true
      },
      isSavingWithPost() {
        return this.pendingSave && this.saveOnly === false
      },
      dynamicParams() {
        return this.category && this.category.params
      },
      isShowContent() {
        return !(this.isEditPage && (!this.loaded || this.pendingLoad))
      },
      mutedList() {
        return {
          main: this.$store.state.vacancyEdit.main.muted,
          characteristicsSchedule: this.$store.state.vacancyEdit.characteristicsSchedule.muted,
          characteristicsSalary: this.$store.state.vacancyEdit.characteristicsSalary.muted,
          characteristicsInhabitancy: this.$store.state.vacancyEdit.characteristicsInhabitancy.muted,
          characteristicsDynamicParams: this.$store.state.vacancyEdit.characteristicsDynamicParams.muted,
          characteristicsAdditional: this.$store.state.vacancyEdit.characteristicsAdditional.muted,
          workPlace: this.$store.state.vacancyEdit.workPlace.muted,
          requirements: this.$store.state.vacancyEdit.requirements.muted,
          files: this.$store.state.vacancyEdit.files.muted,
          images: this.$store.state.vacancyEdit.images.muted
        }
      },
      isSomeMuted() {
        for (const key in this.mutedList) {
          if (this.mutedList[key]) {
            return true
          }
        }

        return false
      },
      shouldPreventReload() {
        return !this.saved && this.isSomeMuted
      }
    },
    methods: {
      onSave(withPost, withoutMessage, redirect) {
        const vacancyId = this.$route.params.vacancyId
        this.$store.dispatch('vacancyEdit/saveAll', {withPost, vacancyId}).then((data) => {
          if(!data) return
          this.saved = true
          this.$router.push(redirect || {name: 'account-vacancies'})

          if(!withoutMessage) {
            this.$vModal.open('message', {
              title: this.$tNewVacancy('Vacancy successfully saved'),
              message: this.$tNewVacancy(data.message)
            })
          }
        })
      },
      saveJobTypes() {
        if (!this.vacancy) return
        const sendData = this.$refs['main'].getJobTypes()

        return http.post(`/api/vacancy/${this.vacancy.id}/job-types`, sendData).then(({data}) => {
          // console.log('/api/vacancy', data)
          this.job_types = data.data
        })
      },
      saveSalary() {
        if (!this.vacancy) return
        const sendData = this.$refs['main'].getJobSalary()

        return http.put(`/api/vacancy/${this.vacancy.id}/salary`, sendData).then(({data}) => {
          // console.log('/api/vacancy', data)
          this.salary = data.data
        })
      },
      saveSchedule() {
        if (!this.vacancy) return
        const sendData = this.$refs['characteristics'].getSchedule()
        // console.log(sendData)

        return http.put(`/api/vacancy/${this.vacancy.id}/chars/schedule`, sendData).then(({data}) => {
          this.schedule = data.data
        })
      },
      saveSalaryType() {
        if (!this.vacancy) return
        const sendData = this.$refs['characteristics'].getSalary()
        // console.log(sendData)
        return http.put(`/api/vacancy/${this.vacancy.id}/chars/salary`, sendData).then(({data}) => {
          this.salaryType = data.data
        })
      },
    },
    created() {
      if(this.isEditPage) {
        this.$store.dispatch('vacancyEdit/loadVacancy', this.$route.params.vacancyId).then(() => {
          this.saved = false
        })
      }
      this.$store.dispatch('vacancyEdit/subscribeMutation')
    },
    async beforeDestroy() {
      await this.$store.dispatch('vacancyEdit/resetState')
    }
  }
</script>

<style lang="less">

</style>
